import './news-card.scss';

/**
 * version    1.0
 * class      <type> (news card component)
 * classdesc  Main news card
 */
export class NewsCard {}
